/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type COMMENT_VIEWER_ACTION = "APPROVE" | "CREATE" | "EDIT" | "REJECT" | "%future added value";
export type ReplyListCommentContainer_comment = {
    readonly id: string;
    readonly enteredLive: boolean | null;
    readonly lastViewerAction: COMMENT_VIEWER_ACTION | null;
    readonly " $fragmentRefs": FragmentRefs<"CommentContainer_comment" | "IgnoredTombstoneOrHideContainer_comment" | "DeletedTombstoneContainer_comment">;
    readonly " $refType": "ReplyListCommentContainer_comment";
};
export type ReplyListCommentContainer_comment$data = ReplyListCommentContainer_comment;
export type ReplyListCommentContainer_comment$key = {
    readonly " $data"?: ReplyListCommentContainer_comment$data;
    readonly " $fragmentRefs": FragmentRefs<"ReplyListCommentContainer_comment">;
};



const node: ReaderFragment = ({
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ReplyListCommentContainer_comment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "CommentContainer_comment"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "IgnoredTombstoneOrHideContainer_comment"
        },
        {
            "args": null,
            "kind": "FragmentSpread",
            "name": "DeletedTombstoneContainer_comment"
        },
        {
            "kind": "ClientExtension",
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "enteredLive",
                    "storageKey": null
                },
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "lastViewerAction",
                    "storageKey": null
                }
            ]
        }
    ],
    "type": "Comment",
    "abstractKey": null
} as any);
(node as any).hash = 'c648254be1b62f056028981e6a68039c';
export default node;
